import { render, staticRenderFns } from "./contactComponent.vue?vue&type=template&id=8d1d2810&scoped=true&"
import script from "./contactComponent.vue?vue&type=script&lang=js&"
export * from "./contactComponent.vue?vue&type=script&lang=js&"
import style0 from "./contactComponent.vue?vue&type=style&index=0&id=8d1d2810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1d2810",
  null
  
)

export default component.exports